export const DATASETS = {
  MY: 'my',
  AOA: 'aoa',
  TASKING: 'tasking',
};

export let DEFAULT_DATASET = DATASETS.MY;

export const setDefaultDataset = ds => (DEFAULT_DATASET = ds);
